import { GetCostsQueryResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCosts/getCostsQuery.type';
import { IBodyGetCostsQueryParams } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCosts/getBodyCostsQuery.type';
import { getBodyCostsQueryFunction } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyCosts/getBodyCostsQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getBodyShowCostsQueryOptions = (
  params: IBodyGetCostsQueryParams,
) => {
  return queryOptions({
    queryKey: ['body-show-costs', params],
    queryFn: () => getBodyCostsQueryFunction(params),
    select: (data: GetCostsQueryResponseType) => {
      return {
        totalPrice: data?.parts_damage_total,
        showCosts: [
          {
            label: 'هزینه حمل و نقل :',
            value: `${data?.parts_transportation?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'ارزش قطعات داغی :',
            value: `${data?.parts_daghi?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'کسورات :',
            value: `${data?.parts_reduction?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'ارزش روز وسیله‌نقلیه :',
            value: `${data?.vehicle_price?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'هزینه لوازم تعویضی :',
            value: `${data?.parts_cost?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'هزینه اجرت تعمیرات : ',
            value: `${data?.parts_payment?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'بالاترین ارزش لاشه :',
            value: `${data?.parts_max_body_price?.toLocaleString('fa') ?? 0} ریال`,
          },
          {
            label: 'کسورات بازدید سلامت قبلی :',
            value: `${data?.parts_prev_reduction?.toLocaleString('fa') ?? 0} ریال`,
          },
        ],
      };
    },
  });
};
